// src/components/ProtectedRoute.tsx
import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }: { children: ReactNode }) {
  const { currentUser, accountStatus, businessId, initializing, sessionIssue } = useAuth();

  if (initializing) {
    return <div style={{ padding: 24 }}>Loading…</div>;
  }

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  if (accountStatus === "pending_verification") {
    return <Navigate to="/verify-email" replace />;
  }

  if (accountStatus === "suspended") {
    return <Navigate to="/login?error=suspended" replace />;
  }

  if (sessionIssue === "account_exists_for_email") {
    return <Navigate to="/account-link-required" replace />;
  }

  if (!businessId) {
    return <Navigate to="/onboarding" replace />;
  }

  return <>{children}</>;
}
